import { createSlice } from '@reduxjs/toolkit';
import { Course } from '../../../lib/interfaces/Course';

type InitialState = {
	courseData: Course | null;
};

const initialState: InitialState = {
	courseData: null,
};

const courseReducer = createSlice({
	name: 'course',
	initialState,
	reducers: {
		setCourseParams: (state, action) => {
			state.courseData = action.payload;
		},
	},
});

export const { setCourseParams } = courseReducer.actions;
export default courseReducer;
